import React from 'react';
import Container_2 from "assets/images/Container-2.png";
import Partners from './Partners';

const ImpactSection = () => {
  return (
    <div className="w-full bg-white">
      {/* Sección de Partners */}
      <Partners />

      {/* Sección principal IMPACT */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row-reverse items-center gap-12">
            
            {/* Contenido de texto */}
            <div className="space-y-8 text-center lg:text-left w-full">
              {/* Título IMPACT */}
              <div className="space-y-4">
                <h2 className="text-red-500 font-semibold text-sm uppercase tracking-wider text-center lg:text-left">IMPACT</h2>
                <h3 className="text-3xl lg:text-4xl font-bold text-gray-800 leading-tight text-center lg:text-left">
                  Optimize Your Website And Reach Customers Effortlessly
                </h3>
                <p className="text-gray-600 text-lg leading-relaxed text-center lg:text-left">
                  Azucarai provides comprehensive digital marketing services to help businesses enhance their online presence. 
                  From reputation management to creative search marketing strategies, we offer everything you need to grow your business. 
                  Whether you need a new website build or want to improve your existing one, we've got you covered.
                </p>
              </div>

              {/* Testimonial */}
              <div className="bg-gray-100 rounded-lg p-6">
                <p className="text-gray-700 italic mb-4 text-center lg:text-left">
                  "Willow Glen Pet Hospital needed a digital marketing expert to help them attract new clients and stand out from the competition. We made it happen."
                </p>
                <div className="flex items-center justify-center lg:justify-start space-x-3">
                  <div className="w-10 h-10 bg-red-200 rounded-full flex items-center justify-center">
                    <span className="text-red-600 font-semibold text-sm">DS</span>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-800">Dr. Dhillon</div>
                    <div className="text-sm text-gray-600">Willow Glen Pet Hospital</div>
                  </div>
                </div>
              </div>

              {/* Métricas de impacto */}
              <div className="bg-gray-100 rounded-lg p-6">
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <div className="text-2xl font-bold text-red-600">23%</div>
                    <div className="text-gray-700">Increase in their monthly appointments</div>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="text-2xl font-bold text-red-600">40%</div>
                    <div className="text-gray-700">Increase in monthly revenue</div>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="text-2xl font-bold text-red-600">35%</div>
                    <div className="text-gray-700">Increase in website traffic</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Imagen de estadísticas */}
            <div className="w-full flex justify-center items-center">
                <img className='w-full max-w-2xl' src={Container_2} alt="estadistic about us" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImpactSection;
